export default function FlightsUtilsFactory(
    userService,
    l10nService
) {
    'ngInject';

        return {

            makeTravellersOptions: function(text, number, includeZero) {
                const options = [];
                const start = includeZero ? 0 : 1;
                for (let i = start; i <= number; i++) {
                    if (text === 'Child') {
                        options.push({
                            text: i + ' ' + (
                                i > 1 ? l10nService.localize(text + 'ren') : l10nService.localize(text)),
                            value: i.toString(),
                        });
                    } else {
                        options.push({
                            text: i + ' ' + (
                                i > 1 ? l10nService.localize(text + 's') : l10nService.localize(text)),
                            value: i.toString(),
                        });
                    }
                }
                return options;
            },

            departureTimeWatcher: function(DepartureDate, DepartTimeOptions, DepartTimeSelected, timeOptions) {
                const regionalSettings = userService.getRegionalSettings();
                const departDate = moment(DepartureDate, regionalSettings.dateFormat);
                const now = moment();
                const minHour = now.hour();
                if (departDate.isValid() && departDate.isSame(now, 'day')) {
                    const filteredDepartTimeOptions = _.filter(angular.copy(timeOptions), function(item) {
                        return minHour <= item.startHour;
                    });

                    replaceArray(DepartTimeOptions, filteredDepartTimeOptions);

                    if (!_.find(filteredDepartTimeOptions, DepartTimeSelected)) {
                        _.assign(DepartTimeSelected, DepartTimeOptions[0]);
                    }
                } else {
                    replaceArray(DepartTimeOptions, angular.copy(timeOptions));
                }
            },

            refreshReturnedDate: function() {
                if (!this[0]._date) {
                    return;
                }

                const regionalSettings = userService.getRegionalSettings();
                const departDate = moment(this[0]._date, regionalSettings.dateFormat);
                const returnDate = moment(this[1]._date, regionalSettings.dateFormat);

                if (departDate.isAfter(returnDate)) {
                    this[1]._date = null;
                }
            },

            returnTimeWatcher: function(DepartureDate,
                                         ReturnDate,
                                         ReturnTimeOptions,
                                         DepartTimeSelected,
                                         ReturnTimeSelected,
                                         timeOptions) {
                const regionalSettings = userService.getRegionalSettings();
                const departDate = moment(DepartureDate, regionalSettings.dateFormat);
                const returnDate = moment(ReturnDate, regionalSettings.dateFormat);
                const now = moment();

                let minHour = DepartTimeSelected.startHour;
                if (minHour === 24) {
                    minHour = 0;
                }
                if (minHour === 0 && returnDate.isSame(now, 'day')) {
                    minHour = now.hour();
                }

                if (returnDate.isValid() && departDate.isValid() && returnDate.isSame(departDate, 'day')) {
                    const filteredReturnTimeOptions = _.filter(angular.copy(timeOptions), function(item) {
                        return item.startHour >= minHour;
                    });
                    replaceArray(ReturnTimeOptions, filteredReturnTimeOptions);

                    if (!_.find(filteredReturnTimeOptions, ReturnTimeSelected)) {
                        _.assign(ReturnTimeSelected, ReturnTimeOptions[0]);
                    }
                } else {
                    replaceArray(ReturnTimeOptions, timeOptions);
                }
            },

            moreOptionsApplied: function(search) {
                return ((search.IncludeNearbyAirports === true
                || search.CharityFaresOnly === true
                || search.DirectFlightsOnly === true
                || notIncludeEurostar()
                || isDifferentCabinTypeSelected()
                || search.PreferredAirlinecode));

                function isDifferentCabinTypeSelected() {
                    return (angular.isObject(search.CabinClass))
                    ? search.CabinClass.value !== 2 : search.CabinClass !== 2;
                }

                function notIncludeEurostar() {
                    return (userService.isUKRegion() && search.IncludeEuroStar === false);
                }

            },

            hasOperator: function(flights) {
                let foundOperator = false;

                angular.forEach(
                    flights, function(flight) {
                        if (!foundOperator && flight.OperatingCompanyName) {
                            foundOperator = true;
                        }
                    }
                );

                return foundOperator;
            },

            getOperator: function(flights) {
                const airlines = [];
                let operatedBy = '';
                const MULTIPLE_OPERATORS = 'multiple airlines';

                angular.forEach(
                    flights, function(flight) {
                        if (flight.OperatingCompanyName && airlines.indexOf(flight.OperatingCompanyName) < 0) {
                            airlines.push(flight.OperatingCompanyName);

                            if (!operatedBy) {
                                operatedBy = flight.OperatingCompanyName;
                            }
                        }
                    }
                );

                return (airlines.length > 1) ? MULTIPLE_OPERATORS : operatedBy;
            },

            isSameAirportCheckNeeded,
            checkSameAirports,
            checkGroupSameAirports,
            calculateRoute,
            calculateDates,
            isRoundTripFlight,
            isMultiTripFlight,
            isRoundTripOrMultiTripFlight,
            prepareRulesLink,

            /**
             * Get flight stop
             */
            findFlightStop: function(flightGroup, stopCity) {
                return _.findWhere(flightGroup.FlightStops, {City: stopCity});
            },

            /**
             * Find DESTINATION city for multiflights
             */
            findDestination: function(flightGroups) {
                const delay = [];
                let lastArrivalDate;
                let lastCity = '';
                let counter = 0;

                _.each(flightGroups, function(group) {
                    _.each(group.Flights, function(flight, index, list) {
                        if (index === list.length - 1) {
                            delay[counter] = {
                                stayingTime: new Date(flight.DepartureDate) - new Date(lastArrivalDate),
                                city: lastCity,
                            };
                            counter++;
                            lastArrivalDate = flight.ArrivalDate;
                            lastCity = flight.ArrivalAirportCity;
                        }
                    });
                });

                return _.max(delay, function(element) {
                    return element.stayingTime;
                }).city;
            },

            /**
             * Collect all visited cities in flight except stops
             */
            collectAllCities: function(flightGroups) {
                const cities = [];
                let stops = [];
                _.each(flightGroups, function(group) {
                    stops = _.pluck(group.FlightStops, 'City');
                    _.each(group.Flights, function(flight) {
                        if (!_.contains(stops, flight.DepartureAirportCity)) {
                            cities.push(flight.DepartureAirportCity);
                        }
                        if (!_.contains(stops, flight.ArrivalAirportCity)) {
                            cities.push(flight.ArrivalAirportCity);
                        }
                    });
                });
                return _.uniq(cities, true);
            },

            lastFlight: function(flight) {
                return _.chain(flight.FlightGroups).last()
                    .result('Flights').last()
                    .value();
            },

            // TODO: is it same?
            lastFlightDetector: function(flight) {
                return _.chain(flight.FlightSegments).last()
                    .result('FlightGroups').last()
                    .result('Flights').last()
                    .value();
            },

            /**
             * Find first and last flights in Flight-item of trip
             */
            firstLastFlight: function(flight) {
                return {
                    first: flight.FlightGroups[0].Flights[0],
                    last: this.lastFlight(flight),
                };
            },

            /**
             * Determine flight type
             */
            flightType: function(flight) {
                const characteristic = flight.FlightGroups.length;
                let type = (characteristic === 1) ? 'one' : 'multi';
                type = (characteristic === 2) ? 'round' : type;

                return type;
            },

            /**
             * Compile route of flight
             */
            getRoute: function(flight, separator) {
                const firstPoint = flight.FlightGroups[0].Flights[0].DepartureAirportCity;
                const lastPoint = this.lastFlight(flight).ArrivalAirportCity;
                let destination;
                if (flight.FlightGroups.length === 1) {
                    destination = lastPoint;
                }
                if (flight.FlightGroups.length === 2) {
                    destination = _.last(flight.FlightGroups[0].Flights).ArrivalAirportCity + separator + lastPoint;
                }
                if (flight.FlightGroups.length > 2) {
                    destination = this.findDestination(flight.FlightGroups) + separator + lastPoint;
                }
                return firstPoint + separator + destination;
            },

            getFlightGroupsDaysShift: function(flightGroup) {
                const dDate = moment(flightGroup.Flights[0].DepartureDate, 'YYYY-MM-DD');
                const aDate = moment(flightGroup.Flights[flightGroup.Flights.length - 1].ArrivalDate, 'YYYY-MM-DD');
                let diff = aDate.diff(dDate, 'days');

                if (diff > 0) {
                    diff = '+' + diff;
                } else if (diff < 0) {
                    diff = '' + diff;
                }

                return diff;
            },

            findAmadeusFlights: function(tripDetails) {
                return _.filter(tripDetails.Flights, function(item) {
                    if (item && item.ServiceOption) {
                        return item.ServiceOption.Id === 1;
                    }
                    return false;
                });
            },

            isItemTrain: function(item) {
                return item.FlightGroups[0].Flights[0].Airplane === 'Train';
            },
            getFlightOrTrain,
        };

        function calculateDates(segs, flightType) {
            const regionalSettings = userService.getRegionalSettings();
            const dates = [];
            let limit = 0;
            if (flightType === 'roundtrip') {
                limit = 1;
            } else if (flightType === 'multitrip') {
                limit = 3;
            }
            for (let i = 0; i <= limit; i++) {
                if (segs[i]._date) {
                    dates.push(moment(segs[i]._date, regionalSettings.dateFormat)
                        .format(regionalSettings.mediumDayMonthDateFormat));
                }
            }
            return dates.join(' — ');
        }

        function calculateRoute(segments, flightType) { // eslint-disable-line
            const segs = angular.copy(segments);

            let route = '';
            if (!segs[0]._departure.name) {
                segs[0]._departure.name = segs[0]._departure.CityName + ', ' + segs[0]._departure.CountryCode;
            }
            if (!segs[0]._arrival.name) {
                segs[0]._arrival.name = segs[0]._arrival.CityName + ', ' + segs[0]._arrival.CountryCode;
            }

            if (segs[0]._departure) {
                route += segs[0]._departure.name + ' → ' + segs[0]._arrival.name;
            }

            if (['roundtrip'].indexOf(flightType) !== -1 && segs[0]._departure.name) {
                route = segs[0]._departure.name + ' ⇄ ' + segs[0]._arrival.name;
            }

            if (['multitrip'].indexOf(flightType) !== -1) {
                for (let item = 1; item <= 3; item++) {
                    if (segs[item]._departure) {
                        createMultitripRoute(item);
                    }
                }
            }

            /**
             * Create route for multitrip
             */
            function createMultitripRoute(i) {
                if (!segs[i]._departure.name) {
                    segs[i]._departure.name = segs[i]._departure.CityName + ', ' + segs[i]._departure.CountryCode;
                }
                if (!segs[i]._arrival.name) {
                    segs[i]._arrival.name = segs[i]._arrival.CityName + ', ' + segs[i]._arrival.CountryCode;
                }

                if (segs[i]._departure.name) {
                    route += (segs[i - 1]._arrival.name !== segs[i]._departure.name
                    && segs[i + 1] && segs[i + 1]._departure)
                        ? ' — ' + segs[i]._departure.name
                        : ' — ' + segs[i]._arrival.name;
                }
            }

            return route;
        }

        function isRoundTripFlight(flightType) {
            return flightType === 'roundtrip';
        }

        function isMultiTripFlight(flightType) {
            return flightType === 'multitrip';
        }

        function isRoundTripOrMultiTripFlight(flightType) {
            return isRoundTripFlight(flightType) || isMultiTripFlight(flightType);
        }

        function checkGroupSameAirports(flightGroup, segmentIndex, departureBlock) {
            const segmentsData = [];

            angular.forEach(flightGroup, function(group) {
                segmentsData.push(group.Flights[0]);
            });

            return checkSameAirports(segmentsData, segmentIndex, departureBlock);
        }

        function checkSameAirports(flightSegments, segmentIndex, isDepartureBlock) {
            return isSameAirportCheckNeeded(flightSegments, isDepartureBlock, segmentIndex)
                ? checkForSameAirportsNames() : false;

            function checkForSameAirportsNames() {
                if (segmentIndex === 0) {
                    if (isDepartureBlock) {
                        return flightSegments[0].DepartureAirport !== flightSegments[flightSegments.length - 1].ArrivalAirport;
                    }
                        return flightSegments[0].ArrivalAirport !== flightSegments[flightSegments.length - 1].DepartureAirport;

                } else if (isDepartureBlock) {
                        return flightSegments[0].ArrivalAirport !== flightSegments[flightSegments.length - 1].DepartureAirport;
                    }
                        return flightSegments[0].DepartureAirport !== flightSegments[flightSegments.length - 1].ArrivalAirport;

            }
        }

        function isSameAirportCheckNeeded(flightSegments, isDepartureBlock, segmentIndex) {

            /**
             * Don't highlight airport for oneway or multiply flights
             */
            if (flightSegments.length !== 2) {
                return false;
            }

            /**
             * (temporary) Don't highlight flight stops
             */
            return !(segmentIndex !== 0 && segmentIndex !== (flightSegments.length - 1));


        }

        function getFlightOrTrain(flight) {
            return flight.Airplane === 'Train' ? 'Train' : 'Flight';
        }

        function prepareRulesLink(flight, fareId, flightGroupIndexes, travellers, searchId) {
            const groupIds = [];
            angular.forEach(
                flightGroupIndexes, function(groupIndex, segmentIndex) {
                    const flightGroup = flight.FlightSegments[segmentIndex].FlightGroups[groupIndex];

                    if (flightGroup) {
                        groupIds.push(flightGroup.FlightGroupId);
                    }
                }
            );

            return {
                fare: flight.FareRecommendations[fareId].FareRecommendationGuid,
                recommendation: flight.RecommendationId,
                search: searchId,
                adult: _.has(travellers.Adult, 'value') ? travellers.Adult.value : travellers.Adult.length,
                child: _.has(travellers.Child, 'value') ? travellers.Child.value : travellers.Child.length,
                infant: _.has(travellers.Infant, 'value') ? travellers.Infant.value : travellers.Infant.length,
                groups: groupIds,
                culture: userService.getCulture(),
            };
        }

        function replaceArray(source, target) {
            Array.prototype.splice.apply(source, [0, source.length].concat(target));
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/services/trains-utils.js